import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Logo officiel CI-VILLE (bâtiments formant un C). Fichiers tirés des originaux de
 * D:\2026\CI-VILLE\Logo vers public/brand.
 *  - variant « white » : sur fond de couleur (en-tête, panneaux) ; « color » : sur fond clair
 *  - full : symbole + mot-symbole « CI-VILLE » ; sinon le symbole seul
 */
export function CiVilleLogo({ className, variant = 'white', full = false, }) {
    const src = `/brand/logo-${full ? 'civille' : 'c'}${variant === 'white' ? '-white' : ''}.png`;
    return (_jsx("img", { src: src, alt: full ? 'CI-VILLE' : '', "aria-hidden": full ? undefined : true, draggable: false, className: `object-contain ${className ?? ''}` }));
}
//# sourceMappingURL=CiVilleLogo.js.map